import { CheckCircleIcon } from "@chakra-ui/icons";
import { Box, Flex, SimpleGrid, Text } from "@chakra-ui/react";
import moment from "moment";
import { useState } from "react";

const ViewAllAddress = ({ data, onSelect }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const formatDate = (value) => {
    const formattedDate = moment(value, "YYYYMMDD", true);
    return formattedDate.isValid() ? formattedDate.format("MM-DD-YYYY") : value;
  };

  const handleSelect = (index) => {
    setSelectedIndex(index);
    onSelect?.(data[index]); // Send selected address to parent if callback provided
  };

  return (
    <Box minH="50vh" h="100%">
      <SimpleGrid columns={2} spacing={4}>
        {data.map((addr, index) => {
          const isSelected = index === selectedIndex;

          return (
            <Box
              key={index}
              bg={isSelected ? "blue.100" : "gray.100"}
              borderRadius="md"
              p={2}
              border={isSelected ? "2px solid #3182CE" : "1px solid #E2E8F0"}
              cursor="pointer"
              onClick={() => handleSelect(index)}
              position="relative"
            >
              {isSelected && (
                <CheckCircleIcon
                  color="blue.500"
                  boxSize={5}
                  position="absolute"
                  top={2}
                  right={2}
                />
              )}
              <SimpleGrid columns={2} mt={2}>
                {Object.entries(addr)
                  .filter(([key]) => key !== "id")
                  .map(([key, value]) => {
                    const formattedValue = key.toLowerCase().includes("date")
                      ? formatDate(value)
                      : value;

                    return (
                      <Flex
                        key={key}
                        alignItems="center"
                        justifyContent="space-evenly"
                        fontSize="sm"
                      >
                        <Box textAlign="left" w="50%" fontWeight={500} mb={1}>
                          {key.replace(/_/g, " ")}
                        </Box>
                        <Box textAlign="center"> : </Box>
                        <Box textAlign="left" width="50%" ml={4}>
                          <Text>{formattedValue || "N/A"}</Text>
                        </Box>
                      </Flex>
                    );
                  })}
              </SimpleGrid>
            </Box>
          );
        })}
      </SimpleGrid>
    </Box>
  );
};

export default ViewAllAddress;
